module.exports = __webpack_public_path__ + "img/tutorial-f03-02.6d8b7de7.png";